<div class="alphabet-filters">
    <div *ngFor="let letterRow of lettersInRows">
        <div id="{{idPrefix}}btn.{{char}}"
             class="text-center"
             *ngFor="let char of letterRow.split('')"
             (click)="selectLetter(char)"
             [ngClass]="{ 'active': char === letter }">
            {{ char }}
        </div>
    </div>
</div>
